import React, { FC } from 'react';
import { useField } from 'formik';
import { Checkbox } from 'src/common/form/checkbox';

interface CheckboxPropsInterface {
  id: string;
  name: string;
  label?: string;
  labelClasses?: string;
  containerClasses?: string;
  disabled?: boolean;
  isBedrock?: boolean;
}

export const FormikCheckbox: FC<CheckboxPropsInterface> = ({
  children,
  id,
  labelClasses,
  containerClasses,
  label,
  disabled,
  isBedrock,
  ...rest
}) => {
  // We need to tell useField what type of input this is
  // since React treats radios and checkboxes differently
  // than inputs/select/textarea.
  const [field, meta] = useField({ ...rest, type: 'checkbox' });
  const hasError = meta.touched && Boolean(meta.error);

  return (
    <Checkbox
      className={containerClasses}
      id={id}
      inputProps={{ ...rest, ...field }}
      checked={field.checked}
      disabled={disabled}
      onChange={field.onChange}
      error={hasError && meta.error}
      label={label}
      labelClassName={labelClasses}
      isBedrock={isBedrock}
    />
  );
};
